import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IFundingDetails } from "src/app/interfaces/member.interface";
import { NormalizeStringPipe } from "src/app/pipe/normalist-string.pipe";

@Component({
    templateUrl: './loan-card.component.html',
    selector: 'lok-loan-card',
    styleUrls: ['./loan-card.component.scss'],
    standalone: false
})
export class LoanCardComponent {
    @Input() fund!: IFundingDetails;
    @Input() index!: number;
    @Input() readOnly = false;
    @Input() livelihoodActivitiesData: any[] = [];
    @Output() editLoan = new EventEmitter();
    @Output() deleteLoan = new EventEmitter();

    edit () {
        this.editLoan.emit({ index: this.index });
    }

    delete () {
        this.deleteLoan.emit({ index: this.index });
    }
    getLabelByValue(value: string): string | null {
  for (const group of this.livelihoodActivitiesData) {
    const found = group.data.find((item:any) => item.value === value);
    if (found) {
      return found.label; // or found.enLabel if you want English label
    }
  }
  return null;
}
}
